<template>
  <el-date-picker
    v-model="computedValue"
    type="datetime"
    placeholder="选择日期时间"
    clearable
    value-format="yyyy-MM-dd HH:mm:ss"
    :picker-options="{
      disabledDate: (time) => {
        return time.getTime() < Date.now() - 3600 * 1000 * 24;
      },
    }"
    :disabled="!editable"
    style="width: 350px"
  >
  </el-date-picker>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
};
</script>

<style lang="scss" scoped></style>
